import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { UnifiedAsset } from '@/hooks/useAssetsUnified';

export function useAssetDetailDrawer() {
  const navigate = useNavigate();
  const [detailAsset, setDetailAsset] = useState<UnifiedAsset | null>(null);
  const [showDetailDrawer, setShowDetailDrawer] = useState(false);
  const [detailMode, setDetailMode] = useState<'view' | 'create' | 'edit'>('view');

  const handleAddAsset = useCallback(() => {
    navigate('.', { state: { openCreate: true } });
  }, [navigate]);

  const handleEditAsset = useCallback((asset: UnifiedAsset) => {
    if (asset.source_type !== 'manual') {
      console.warn('Cannot edit connected or account assets - they are synced from providers');
      return;
    }
    setDetailAsset(asset);
    setDetailMode('edit');
    setShowDetailDrawer(true);
  }, []);

  const handleViewDetails = useCallback((asset: UnifiedAsset) => {
    setDetailMode('view');
    setDetailAsset(asset);
    setShowDetailDrawer(true);
  }, []);

  const handleCloseDetailDrawer = useCallback(() => {
    setShowDetailDrawer(false);
    setDetailAsset(null);
    setDetailMode('view');
  }, []);

  return {
    detailAsset,
    setDetailAsset,
    showDetailDrawer,
    setShowDetailDrawer,
    detailMode,
    setDetailMode,
    handleAddAsset,
    handleEditAsset,
    handleViewDetails,
    handleCloseDetailDrawer,
  };
}
